import LyTitle from './src/index.vue'

LyTitle.install = function (Vue) {
    Vue.component(LyTitle.name, LyTitle)
}

export default LyTitle



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/title/index.js
// module id = null
// module chunks = 